import { SchmancyElement } from '@schmancy/mixins/index'
import { css, html } from 'lit'
import { customElement } from 'lit/decorators.js'
import './spinner'

@customElement('schmancy-busy')
export default class SchmancyBusy extends SchmancyElement {
	static styles = [
		css`
			:host {
				display: inline;
				position: absolute;
				inset: 0;
				pointer-events: all;
				z-index: 50;
			}
		`,
	]
	protected render(): unknown {
		return html`
			<div
				class="absolute inset-0 flex items-center justify-center bg-surface-container/10 backdrop-blur-xs rounded-[inherit]"
			>
				<div class="relative flex items-center justify-center p-4">
					<div class="relative z-10">
						<slot>
							<schmancy-spinner></schmancy-spinner>
						</slot>
					</div>
				</div>
			</div>
		`
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'schmancy-busy': SchmancyBusy
	}
}
